export const PERFORMANCE_BUDGETS = Object.freeze({
  clickResponse: 16,
  stateUpdate: 10,
  workspaceRender: 50,
  bootstrapRefresh: 150,
  configurationLookup: 20,
  routeNavigation: 150,
  livePageEditSave: 250,
  experienceResolution: 20,
});

export const PERFORMANCE_BUDGET_LABELS = Object.freeze({
  clickResponse: 'Click response', stateUpdate: 'State update', workspaceRender: 'Workspace render',
  bootstrapRefresh: 'Bootstrap refresh', configurationLookup: 'Configuration lookup', routeNavigation: 'Route navigation',
  livePageEditSave: 'Live Page Edit save', experienceResolution: 'Experience resolution',
});

export const classifyInteraction = (target) => {
  const element = target?.closest?.('a,button,input,select,textarea,[role="button"],[role="tab"],[role="menuitem"],[data-og-workspace-id]');
  const tag = element?.tagName?.toLowerCase() || 'document';
  const role = element?.getAttribute?.('role') || '';
  const label = element?.getAttribute?.('aria-label') || element?.textContent?.trim().replace(/\s+/g, ' ').slice(0, 80) || element?.getAttribute?.('name') || tag;
  const type = tag === 'a' ? 'navigation' : role === 'tab' ? 'tab' : tag === 'select' ? 'dropdown' : ['input', 'textarea'].includes(tag) ? 'input' : tag === 'button' || role === 'button' ? 'button' : 'interaction';
  return { element, tag, role, label, type, component: element?.getAttribute?.('data-og-component') || element?.className?.toString().split(/\s+/)[0] || tag, experienceDomain: element?.closest?.('[data-og-experience-domain]')?.getAttribute('data-og-experience-domain') || 'application', canonicalOwner: element?.closest?.('[data-og-canonical-owner]')?.getAttribute('data-og-canonical-owner') || 'unexposed' };
};

export const budgetForInteraction = (interaction) => interaction.type === 'navigation' ? PERFORMANCE_BUDGETS.routeNavigation : PERFORMANCE_BUDGETS.clickResponse;
